import { render, staticRenderFns } from "./AtendimentoPainel.vue?vue&type=template&id=f451c0a8&scoped=true"
import script from "./AtendimentoPainel.vue?vue&type=script&lang=js"
export * from "./AtendimentoPainel.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoPainel.vue?vue&type=style&index=0&id=f451c0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f451c0a8",
  null
  
)

export default component.exports